export const WEIGHT_UNIT_ENUM = {
  KGM: 'KGM',
  LTR: 'LTR',
  PCE: 'PCE',
  NAR: 'NAR',
  DOS: 'DOS',
  TNE: 'TNE',
};
